// extracted by mini-css-extract-plugin
export default {"projectSettings":"ProjectSettingsForm_projectSettings__ZH7PP"};